<template>
  <div class="container">

    <div>
      <div class="columns">
        <div class="column col-2 text-bold">
          Reference
        </div>
        <div class="column col-2 text-bold">
          Date
        </div>
        <div class="column col-4 text-bold">
          Description
        </div>
        <div class="column col-1 col-ml-auto text-bold">
          Status
        </div>
      </div>
    </div>

    <div v-for="(inv, i) in invoices" class="tile ClientPayment">
      <div class="tile-content">
        <span class="tile-title c-hand" @click="setInv(inv)">
          <div class="container">
            <div class="columns">
              <div class="column col-2">{{inv.ref}}</div>
              <div class="column col-2">{{date(inv.date)}}</div>
              <div class="column col-4">{{inv.matter_desc}}</div>
              <div class="column col-1 col-ml-auto">
                <div class="tile-icon">
                  <span v-if="inv.paid" class="label label-success">Paid</span>
                  <span v-else class="label label-warning">Unpaid</span>
                </div>
              </div>
            </div>
          </div>
        </span>

        <!-- INVOICE CONTENT -->
        <div v-if="sel_inv === inv">

          <table class="table">
            <thead>
              <tr>
                <th>Item description</th>
                <th>Cost</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in inv.items">
                <td>{{item.description}}</td>
                <td>${{c2d(item.cost)}}</td>
              </tr>
              <tr v-if="inv.gst">
                <td>GST (10%)</td>
                <td>${{c2d(inv.gst)}}</td>
              </tr>
              <tr v-if="inv.surcharge">
                <td>Surcharge (1.4%)</td>
                <td>${{c2d(inv.surcharge)}}</td>
              </tr>
              <tr>
                <td>Total</td>
                <td>${{c2d(inv.total)}}</td>
              </tr>
              <tr v-if="!inv.paid">
                <td></td>
                <td><button v-if="showPayBtn" class="btn btn-primary" @click="showPay = true">Pay</button></td>
              </tr>
            </tbody>
          </table>

          <div v-if="inv.plan" class="paymentPlanTable">
            <table class="table">
              <thead>
                <tr>
                  <th colspan="3"><h4>Your payment plan</h4></th>
                </tr>
                <tr>
                  <th>Monthly payment amount: ${{c2d(inv.monthly)}}</h4></th>
                  <th>Remaining: ${{c2d(inv.outstanding)}}</th>
                  <th></th>
                </tr>
                <tr>
                  <th>Date</th>
                  <th>Monthly amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="payment in payments(inv)">
                  <td v-if="inv.last_payment">{{payment.date}}</td>
                  <td v-else>Upcoming</td>
                  <td>${{c2d(payment.amount)}}</td>
                  <td>
                    <span v-if="payment.paid" class="label label-rounded label-success">Paid</span>
                    <span v-else class="label label-rounded label-warning">Scheduled</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- END INVOICE CONTENT -->

      </div>
    </div>

    <payment :invoice="sel_inv" :active="showPay" v-on:hide="showPay = false" v-on:payment="getInvoices"></payment>

  </div>
</template>

<script>
import axios from 'axios'
import utils from '@/components/utils'
import payment from '@/components/accounts/paymentModal'

export default {
  name: 'clientInvoices',
  mixins: [utils],
  components: { payment },
  data () {
    return {
      invoices: [],
      sel_inv: null,
      chargeAmount: 0,
      error: '',
      stripe: null,
      card: null,
      showPay: false,
      success: false,
      loading: false
    }
  },
  created () {
    this.$root.$data.pageTitle = 'Invoices'
    this.getInvoices()
  },
  computed: {
    showPayBtn () {
      let inv = this.sel_inv
      if (!inv || inv.paid) return false
      if (inv.plan) {
        return inv.payments.length === 0
      }
      return true
    }
  },
  methods: {
    getInvoices () {
      let _id = this.$root.$data.user._id
      axios.get('/api/userinvoices/' + _id).then(res => {
        if (res.status === 200) {
          this.invoices = res.data
        }
      })
    },
    date (d) {
      return new Date(d).toLocaleDateString()
    },
    setInv (inv) {
      this.sel_inv = this.sel_inv === inv ? null : inv
    },
    c2d (c) {
      return (c / 100).toFixed(2)
    }
  }
}
</script>

<style scoped>
.invoice-title {
  cursor: pointer;
}
.tile.ClientPayment {
  padding: 1em 0;
  border-bottom: 1px solid #e7e9ed
}
.table tr:last-child {
  border-bottom: none;
}
.table tr:last-child td {
  border-bottom: none;
}
.paymentPlanTable {
  background: #3fa9f512;
  border: 1px solid #3fa9f5;
  border-radius: 2px;
  margin: 2em 0;
  padding: 2em;
}
.paymentPlanTable th,
.paymentPlanTable tr,
.paymentPlanTable td {
  border-bottom: 1px solid #3fa9f5;
  border: none;
}
</style>



// WEBPACK FOOTER //
// clientInvoices.vue?937a1b64